import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import axios from '@/api/axios';

// TODO: коммит сделан как backend commit для PG(((
Vue.use(VueToast);
// TODO: перенос в Vue Component
const openToast = (message, type) => {
  Vue.$toast.open({
    message,
    type,
  });
};

export const getListPack = async (userId) => {
  const { data } = await axios.get(`/schedule/list/?userId=${userId}`);
  if (data.success) return data.result;
  openToast(data.message, 'error');
  return null;
};

export const getListPeportInPack = async (packId, userId) => {
  const { data } = await axios.get(`/schedule/list/reports/?packId=${packId}&userId=${userId}`);
  if (data.success) return data.result;
  openToast(data.message, 'error');
  return null;
};

export const getListCompAndFreqOfExecution = async (shedId, userId) => {
  const { data } = await axios.get(`/schedule/list/comp/?shedId=${shedId}&userId=${userId}`);
  if (data.success) return data.result;
  openToast(data.message, 'error');
  return null;
};

export const getDayWeek = async (shedId) => {
  const { data } = await axios.get(`/schedule/list/comp/dayWeek?shedId=${shedId}`);
  if (data.success) return data.result;
  openToast(data.message, 'error');
  return null;
};

export const getExpRepPack = async (packId) => {
  const { data } = await axios.get(`/schedule/list/comp/repPack?packId=${packId}`);
  if (data.success) return data.result;
  openToast(data.message, 'error');
  return null;
};

export const saveRepPack = async (params) => {
  const { data } = await axios.post('/schedule/savePack', params);
  if (data.success) return data.result;
  openToast(data.message, 'error');
  return null;
};

export const deleteReportPack = async (packId) => {
  const { data } = await axios.delete(`/schedule/deletePack/${packId}`);
  if (data.success) return data.result;
  openToast(data.message, 'error');
  return null;
};

export const renameReportPack = async (packId, name) => {
  const { data } = await axios.post(`/schedule/changeName/?packId=${packId}&name=${name}`);
  if (data.success) return data.result;
  openToast(data.message, 'error');
  return null;
};

export const changeRepPack = async (params) => {
  const { data } = await axios.post('/schedule/changeRepPack/', params);
  if (data.success) return data.result;
  openToast(data.message, 'error');
  return null;
};
